import { memo } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router-dom';
import SecuritySetupPrompt from '../components/SecuritySetupPrompt';
import Footer from './Footer';
import Nav from './Nav';

const Layout = memo(() => {
  return (
    <div className="min-h-full">
      <Nav />
      <main>
        <div className="flex flex-1 flex-col lg:pl-64">
          <Outlet />
        </div>
      </main>
      <Footer />
      <SecuritySetupPrompt />
      {/* The one toast outlet for every signed-in page. */}
      <Toaster position="top-center" />
    </div>
  );
});

export default Layout;
